
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsUnitGrid extends Serenity.EntityGrid<CsUnitRow, any> {
        protected getColumnsKey() { return CsUnitColumns.columnsKey; }
        protected getDialogType() { return CsUnitDialog; }
        protected getIdProperty() { return CsUnitRow.idProperty; }
        protected getInsertPermission() { return CsUnitRow.insertPermission; }
        protected getLocalTextPrefix() { return CsUnitRow.localTextPrefix; }
        protected getService() { return CsUnitService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}